import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import  dateFormat from  "dateformat" ; 

export default function History() {
  const [history, setHistory] = useState([]);
  let listItems;
  
  const navigate = useNavigate ();
  const myUser = useAuth();
 
  // User logged ?
  useEffect(() => {
    if (myUser === null) { navigate('/'); }
  }, [myUser]);

  // Load user prefs
  useEffect(() => {
    async function getUserHistory() {
      fetch(process.env.REACT_APP_API_SERVER + '/api/user/'+ myUser.id +'/history', { 
        method: 'get', 
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + myUser.token} 
      })
      .then(response => response.json())
      .then(data => checkHistory(data));
      return;
    }
    getUserHistory();
  }, []);

  // Set user prefs
  const checkHistory = (res) => {
    if (res.status !== 'error') {
      listItems = res.map((row, idx) => <tr key={idx}><td>{row.id}</td><td>{dateFormat(new Date(row.played_at), "dd/mm/yyyy")}</td><td>{row.level}</td><td>{row.status === 'closed' ? 'Terminé' : 'En cours'}</td></tr>);
      setHistory(listItems);
    }
  }
  
  return (
    <div>
        <h1>Historique des scores</h1>
        <table cellPadding={3} cellSpacing={0} className="history" width="90%">
          <thead>
            <tr><th>N° Partie</th><th>Date</th><th>Max score</th><th>Statut</th></tr>
          </thead>
          <tbody>
            { history }
          </tbody>
        </table>
    </div>
  );
}